import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryGridSection from './components/CategoryGridSection';
import HotPostsSection from './components/HotPostsSection';
import LatestPostsSection from './components/LatestPostsSection';
import GuideSection from './components/GuideSection';
import FaqSection from './components/FaqSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGridSection />
        <HotPostsSection />
        <LatestPostsSection />
        <GuideSection />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}